import { render, staticRenderFns } from "./LmMarca.vue?vue&type=template&id=29affe4f&"
import script from "./LmMarca.vue?vue&type=script&lang=js&"
export * from "./LmMarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports